// Xuất CSV bảng theo ngày — làm hoàn toàn ở trình duyệt (không gọi API thêm).
import { fmtVnDate, missionKeys, missionName } from "./xu-format-helpers";

const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

/** Mỗi ngày 1 dòng; BOM đầu file để Excel đọc đúng tiếng Việt. */
export function buildDailyCsv(days, titles = {}) {
    const MISSION_KEYS = missionKeys(days, titles);
    const head = ["Ngày", "Xu phát", "Xu thu hồi", "Người điểm danh", ...MISSION_KEYS.flatMap((k) => [`${missionName(k, titles)} - xong`, `${missionName(k, titles)} - đã nhận`])];
    const rows = days.map((d) => [
        fmtVnDate(d.vnDate), d.earned, d.revoked, d.checkins,
        ...MISSION_KEYS.flatMap((k) => [d.missions[k]?.completed || 0, d.missions[k]?.claimed || 0]),
    ]);
    return `﻿${[head, ...rows].map((r) => r.map(esc).join(",")).join("\r\n")}`;
}

export function downloadCsv(filename, text) {
    const url = URL.createObjectURL(new Blob([text], { type: "text/csv;charset=utf-8" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
